import { Component, Input} from '@angular/core';
import { NavController } from 'ionic-angular';
import { ViewChild } from '@angular/core';
import { Slides } from 'ionic-angular';

/**
   * Logger Factory
   * @namespace item: title, subtitle and icon to shoow
   * <ute-intro-slider class="intro-slider" [sliders]="sliders"></ute-intro-slider>
*/

@Component({
  selector: 'ute-intro-slider',
  templateUrl: 'ute-intro-slider.component.html'
})
export class UteIntroSlider  {
  @Input() sliders: any[];
  @ViewChild(Slides) slides: Slides;
  
  public currentIndex: any;

  constructor(public navCtrl: NavController) {
  
  }
   
  ngOnInit() {

  }

  slideChanged() {
    this.currentIndex = this.slides.getActiveIndex() + 1;
  }
  

}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-intro-slider/ute-intro-slider.component.ts